import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { WhyHereSection } from './components/WhyHereSection';
import { TrainingPlansSection } from './components/TrainingPlansSection';
import { SuperfoodsSection } from './components/SuperfoodsSection';
import { MyStorySection } from './components/MyStorySection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { FreeTipsSection } from './components/FreeTipsSection';
import { CartProvider } from './context/CartContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Cart } from './components/Cart';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import { SuperfoodsInfoPage } from './pages/SuperfoodsInfoPage';
import { SuperfoodsPage } from './pages/SuperfoodsPage';
import { TrainingPlansLandingPage } from './pages/TrainingPlansLandingPage';
import { FreeTipsPage } from './pages/FreeTipsPage';
import { trackPageView } from './utils/analytics';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -20
  }
};
const pageTransition = {
  duration: 0.4,
  ease: 'easeInOut'
};
function AnimatedRoutes() {
  const location = useLocation();
  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<motion.main initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-3">
              <HeroSection data-id="element-4" />
              <WhyHereSection data-id="element-5" />
              <TrainingPlansSection data-id="element-6" />
              <MyStorySection data-id="element-7" />
              <FAQSection data-id="element-8" />
              <FreeTipsSection data-id="element-9" />
              <ContactSection data-id="element-10" />
            </motion.main>} data-id="element-2" />

        <Route path="/cart" element={<motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-12">
              <Cart data-id="element-13" />
            </motion.div>} data-id="element-11" />

        <Route path="/superpotraviny-info" element={<motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-15">
              <SuperfoodsInfoPage data-id="element-16" />
            </motion.div>} data-id="element-14" />

        <Route path="/superpotraviny" element={<motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-18">
              <SuperfoodsPage data-id="element-19" />
            </motion.div>} data-id="element-17" />

        <Route path="/treninky" element={<motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-21">
              <TrainingPlansLandingPage data-id="element-22" />
            </motion.div>} data-id="element-20" />

        <Route path="/tipy" element={<motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} data-id="element-24">
              <FreeTipsPage data-id="element-25" />
            </motion.div>} data-id="element-23" />
      </Routes>
    </AnimatePresence>;
}
function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/treninky';
  const isFreeTipsPage = location.pathname === '/tipy';
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-26">
      {!isFreeTipsPage && <Navbar isLandingPage={isLandingPage} data-id="element-27" />}
      <AnimatedRoutes data-id="element-28" />
      {!isFreeTipsPage && <Footer data-id="element-29" />}
    </div>;
}
export function App() {
  useEffect(() => {
    // Initialize Google Tag Manager
    const GTM_ID = 'GTM-T6DQBD49'
    // Create dataLayer if it doesn't exist
    ;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    // Inject GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.insertBefore(script, document.head.firstChild);
    // Inject noscript iframe for GTM
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    // Set title immediately
    document.title = 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama.';
    // Nastavení meta description - delší verze pro Google
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama. Profesionální tréninkové plány a zelené superpotraviny pro rychlé výsledky.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama. Profesionální tréninkové plány a zelené superpotraviny pro rychlé výsledky.';
      document.head.appendChild(meta);
    }
    // Přidání keywords meta tagu pro lepší SEO
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'body-hack, tréninkové plány, fitness, cvičení, superpotraviny, transformace těla, chlorella, ječmen';
      document.head.appendChild(meta);
    }
    // Nastavení author meta tagu
    const metaAuthor = document.querySelector('meta[name="author"]');
    if (!metaAuthor) {
      const meta = document.createElement('meta');
      meta.name = 'author';
      meta.content = 'BODY-HACK';
      document.head.appendChild(meta);
    }
    // Nastavení Open Graph meta tagů pro sdílení
    const setMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };
    // Facebook Meta Tags
    setMetaTag('og:url', 'https://body-hack.cz');
    setMetaTag('og:type', 'website');
    setMetaTag('og:title', 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama.');
    setMetaTag('og:description', 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama. Profesionální tréninkové plány a zelené superpotraviny.');
    setMetaTag('og:image', 'https://cdn.magicpatterns.com/uploads/8uYqSLDJnz8qJRZgE4Tm55/c1f9892b-742c-4106-9d22-7c246781af0d.png');
    setMetaTag('og:image:alt', 'BODY-HACK - Transformuj své tělo');
    setMetaTag('og:site_name', 'BODY-HACK');
    setMetaTag('og:locale', 'cs_CZ');
    // Twitter Card tagy
    const setTwitterTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };
    setTwitterTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:domain', 'body-hack.cz');
    setMetaTag('twitter:url', 'https://body-hack.cz');
    setTwitterTag('twitter:title', 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama.');
    setTwitterTag('twitter:description', 'Transformuj své tělo. Změň svou mysl. Ovládni sebe sama. Profesionální tréninkové plány a zelené superpotraviny.');
    setTwitterTag('twitter:image', 'https://cdn.magicpatterns.com/uploads/8uYqSLDJnz8qJRZgE4Tm55/c1f9892b-742c-4106-9d22-7c246781af0d.png');
    setTwitterTag('twitter:image:alt', 'BODY-HACK - Transformuj své tělo');
    // Canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 'https://body-hack.cz');
  }, []);
  return <CookieConsentProvider data-id="element-30">
      <CartProvider data-id="element-31">
        <Router data-id="element-32">
          <AppContent data-id="element-33" />
          <CookieConsentBanner data-id="element-34" />
        </Router>
      </CartProvider>
    </CookieConsentProvider>;
}